import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import './title.scss';
const Title = ({ label, title, subtitle, darkBackground }) => {
	return (
		<div className={`section-title ${darkBackground && 'dark-text'} `}>
			{label && <p className='label'>{label}</p>}
			{title && (
				<h2 className={`${subtitle === undefined ? 'no-margin' : null}`}>
					{title}
				</h2>
			)}
			{subtitle && <p>{subtitle}</p>}
		</div>
	);
};

export default Title;
